var _defs, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadScreenshotsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".custom{fill:#fff;stroke:#95abd3;stroke-linecap:round;stroke-dasharray:4;}.b{fill:#95abd3;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "custom"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 90,
    height: 90,
    rx: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 89,
    rx: 20.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.668,0H14.793A4.931,4.931,0,0,0,9.862,4.931V9.862H4.931A4.931,4.931,0,0,0,0,14.793V47.668A4.931,4.931,0,0,0,4.931,52.6H37.805a4.931,4.931,0,0,0,4.931-4.931V42.736h4.931A4.931,4.931,0,0,0,52.6,37.805V4.931A4.931,4.931,0,0,0,47.668,0ZM37.189,47.668H5.548a.616.616,0,0,1-.616-.616V15.41a.616.616,0,0,1,.616-.616H9.862V37.805a4.931,4.931,0,0,0,4.931,4.931H37.805v4.315A.616.616,0,0,1,37.189,47.668Zm9.862-9.862H15.41a.616.616,0,0,1-.616-.616V5.548a.616.616,0,0,1,.616-.616H47.051a.616.616,0,0,1,.616.616V37.189A.616.616,0,0,1,47.051,37.805Z",
    transform: "translate(18.7 18.701)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.133,38.4H9.895V33.164A1.164,1.164,0,0,0,8.73,32H7.566A1.164,1.164,0,0,0,6.4,33.164V38.4H1.164A1.164,1.164,0,0,0,0,39.566V40.73a1.164,1.164,0,0,0,1.164,1.164H6.4v5.238A1.164,1.164,0,0,0,7.566,48.3H8.73a1.164,1.164,0,0,0,1.164-1.164V41.895h5.238A1.164,1.164,0,0,0,16.3,40.73V39.566A1.164,1.164,0,0,0,15.133,38.4Z",
    transform: "translate(43 -0.297)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadScreenshotsPlaceholder);
export default __webpack_public_path__ + "static/media/uploadScreenshotsPlaceholder.5943d3c5.svg";
export { ForwardRef as ReactComponent };